import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';

import { ControlError } from '../../models';

@Component({
  selector: 'kt-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
})
export class InputComponent {
  private _control: FormControl;
  required: boolean;
  @ViewChild('input') input: ElementRef;
  @Input() isTextarea: boolean;
  @Input() readonly: boolean;
  @Input() id: string;
  @Input() type: 'text' | 'number' = 'text';
  @Input() mask: string;
  @Input() rows: number; // type: textarea
  @Input() min: number; // type: number
  @Input() max: number; // type: number
  @Input() maxlength: number; // type: text, or textarea
  @Input() label: string;
  @Input() hint: string;
  @Input() placeholder: string;
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() color: 'primary' | 'secondary' | 'tertiary' | 'neutral' = 'neutral';
  @Input() errors: ControlError[] = [];
  @Input()
  set control(control: FormControl) {
    if (!control) return;

    this._control = control;
    this.required = false;

    if (control.validator) {
      const validator = control.validator({} as any);
      this.required = !!validator?.required;
    }
  }
  get control(): FormControl {
    return this._control;
  }
  @Output() focused = new EventEmitter();
  @Output() blurred = new EventEmitter();

  focus(): void {
    this.input.nativeElement.focus();
  }
}
